// Recently Viewed Items utility
// Stores and retrieves recently viewed listings from localStorage
// Supports both WTB ('wtb') and inventory ('inventory') item types

const RECENTLY_VIEWED_KEY = 'wantd_recently_viewed';
const MAX_RECENT_ITEMS = 10;

export const getRecentlyViewed = () => {
  try {
    const stored = localStorage.getItem(RECENTLY_VIEWED_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error('Error reading recently viewed:', e);
    return [];
  }
};

export const addToRecentlyViewed = (listing, type = 'wtb') => {
  try {
    const current = getRecentlyViewed();

    // Remove if already exists (to move to front)
    const filtered = current.filter(item => item.id !== listing.id);

    // Add to front with minimal data
    const newItem = {
      id: listing.id,
      title: listing.title,
      min_price: listing.min_price,
      max_price: listing.max_price,
      price: listing.price,
      category: listing.category,
      location_name: listing.location_name,
      images: listing.images,
      user_id: listing.user_id,
      type: type,
      viewed_at: new Date().toISOString()
    };

    // Keep only MAX_RECENT_ITEMS
    const updated = [newItem, ...filtered].slice(0, MAX_RECENT_ITEMS);

    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(updated));
    return updated;
  } catch (e) {
    console.error('Error saving recently viewed:', e);
    return [];
  }
};

export const clearRecentlyViewed = () => {
  localStorage.removeItem(RECENTLY_VIEWED_KEY);
};
